import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppContext } from '../../appprovider';
import {
  canAccessAdmin,
  canAccessBilling,
  canAccessSystem,
} from '../services/instructorPortalAccess';

const PORTAL_HOME = '/Portal/Instructor';

/** Redirects when the viewer lacks super-admin System access. */
export function RequireSystemAccess({ children }) {
  const userType = localStorage.getItem('userType');
  if (!canAccessSystem(userType)) {
    return <Navigate to={PORTAL_HOME} replace />;
  }
  return children;
}

/** Redirects when the viewer is not an organization admin. */
export function RequireOrgAdminAccess({ children }) {
  const { entitlements } = useAppContext();
  if (!canAccessAdmin(entitlements)) {
    return <Navigate to={PORTAL_HOME} replace />;
  }
  return children;
}

/** Redirects when billing surfaces are not available for this org admin. */
export function RequireBillingAccess({ children }) {
  const { entitlements } = useAppContext();
  if (!canAccessBilling(entitlements)) {
    return <Navigate to={PORTAL_HOME} replace />;
  }
  return children;
}
